import React from "react";

import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import LocalFireDepartmentIcon from "@mui/icons-material/LocalFireDepartment";
import {
  getBatchScheduleDayTimeLabels,
  getEarliestStartDate,
  getStartDateStatus,
} from "utils/batchPreferenceUtils";

import styles from "./BatchPreference.module.scss";

const BatchCard = ({ batch, onSelect }) => {
  const earliestStartDate = getEarliestStartDate(batch.startDates);
  const dateCount = batch.startDates?.length || 0;
  const dayTimeLabels = getBatchScheduleDayTimeLabels(batch);
  const batchNumber = String(batch.label || "").replace(/\D/g, "") || "";

  return (
    <div className={styles.batchCard}>
      <div className={styles.batchCardHeader}>
        <div className={styles.batchCardTitleWrap}>
          <CalendarMonthIcon className={styles.batchCardTitleIcon} />
          <h3 className={styles.batchCardTitle}>{batch.label}</h3>
        </div>
        {earliestStartDate ? (
          <span className={styles.fillingFastOrange}>
            <LocalFireDepartmentIcon className={styles.fillingFastIcon} />
            Filling Fast
          </span>
        ) : null}
      </div>

      <ul className={styles.scheduleList}>
        {dayTimeLabels.map((dayTimeLabel, index) => (
          <li key={`${index}-${dayTimeLabel}`} className={styles.scheduleListItem}>
            <CalendarMonthIcon className={styles.scheduleListIcon} />
            <span>{dayTimeLabel}</span>
          </li>
        ))}
      </ul>

      <div className={styles.startDateInfo}>
        <InfoOutlinedIcon className={styles.startDateInfoIcon} />
        <span>
          {dateCount} start date{dateCount === 1 ? "" : "s"} available
          {earliestStartDate
            ? ` · ${getStartDateStatus(earliestStartDate)}`
            : ""}
        </span>
      </div>

      <button
        type="button"
        className={styles.selectBatchButton}
        onClick={() => onSelect(batch)}
      >
        Select Batch{batchNumber ? ` ${batchNumber}` : ""}
      </button>
    </div>
  );
};

export default BatchCard;
